export function formatRelativeTime(
  iso: string,
  nowMs: number = Date.now(),
  locale?: string,
): string {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return 'recently';
  const ms = nowMs - t;
  const seconds = Math.round(ms / 1000);
  const minutes = Math.floor(Math.abs(seconds) / 60) * Math.sign(seconds);
  const hours = Math.floor(Math.abs(minutes) / 60) * Math.sign(minutes);
  const days = Math.floor(Math.abs(hours) / 24) * Math.sign(hours);
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto', style: 'short' });
  if (Math.abs(days) >= 1) return rtf.format(-days, 'day');
  if (Math.abs(hours) >= 1) return rtf.format(-hours, 'hour');
  if (Math.abs(minutes) >= 1) return rtf.format(-minutes, 'minute');
  return rtf.format(-seconds, 'second');
}
